<template>
  <v-dialog :model-value="modelValue" @update:modelValue="$emit('update:modelValue', $event)" width="500px">
    <v-card>
      <v-card-title>{{ localData.itemToEdit.productName }} ({{ localData.itemToEdit.unit }})</v-card-title>
      <v-card-content>
        <v-container>
          <v-lazy>
            <v-data-table
              :headers="headers"
              :items="localData.itemToEdit.items.filter(item => item.quantity !== 0)"
              hide-default-footer
              class="outlined-table"
            >
              <template v-slot:header.actions>
                <v-btn icon="mdi-plus" size="x-small" @click="addNewItem"></v-btn>
              </template>

              <template v-slot:item.expirationDate="{ item }">
                <v-text-field
                  type="date"
                  v-model="item.expirationDate"
                  outlined
                  density="compact"
                  class="mt-5"
                ></v-text-field>
              </template>

              <template v-slot:item.quantity="{ item }">
                <v-text-field v-model="item.quantity" density="compact" hide-details outlined />
              </template>

              <template v-slot:item.actions="{ item }">
                <v-btn icon="mdi-trash-can" size="x-small" @click="deleteProduct(item)"></v-btn>
              </template>
            </v-data-table>
          </v-lazy>
        </v-container>
      </v-card-content>
      <v-card-actions class="justify-space-between">
        <v-btn color="primary" @click="closeDialog">Annuler</v-btn>
        <div>
          <v-btn v-if="localData.itemToEdit.quantity > 0" color="error" @click="deleteProduct">Delete</v-btn>
          <v-btn color="primary" @click.prevent="saveChanges">Save</v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { defineProps, defineEmits, reactive, watch } from 'vue';
import { cloneDeep } from "lodash";
import snackbarService from '@/services/snackbarService.js';

const headers = [
  { title: "Date", key: "expirationDate", sortable: false, width:"60%" },
  { title: "Quantité", key: "quantity", sortable: false, width:"20%" },
  { text: '', value: 'actions', align: 'center', sortable: false, width:"20%" }
];

const props = defineProps({
  modelValue: Boolean,
  inventoryDialogData: Object
});

const emit = defineEmits(['update:modelValue', 'close', 'save']);

const localData = reactive({
  itemToEdit: {}
});

watch(() => props.inventoryDialogData, (newData) => {
  localData.itemToEdit = cloneDeep(newData.itemToEdit);
}, { immediate: true, deep: true });

const deleteProduct = (item) => {
  item.quantity = 0;
};

const saveChanges = async () => {
  const uniqueDates = new Set();
  for (const item of localData.itemToEdit.items) {
    if (uniqueDates.has(item.expirationDate) && item.quantity !== 0) {
      snackbarService.showSnackbar("Deux produits ne peuvent pas avoir la même date de péremption.", 'error');
      return;
    }
    uniqueDates.add(item.expirationDate);
  }
  emit('save', localData.itemToEdit);
};

const closeDialog = () => {
  emit('close');
};

const addNewItem = () => {
  localData.itemToEdit.items.push({
    id: 0,
    productId: localData.itemToEdit.productId,
    quantity: 1,
    expirationDate: new Date().toJSON().slice(0, 10),
    stockId: 1,
  });
};
</script>

<style scoped>
.v-col {
  display: flex;
  justify-content: center;
  align-items: center;
}

@media (max-width: 600px) {
  .full-width-on-mobile {
    width: 100%;
  }
}
</style>